<template>
  <div>
    <div class="pagination-controls">
      <a @click.prevent="previousPage" :class="{ disabled: offset === 0 }" href="#">Previous</a>
      <a @click.prevent="nextPage" :class="{ disabled: posts.length < pageSize }" href="#">Next</a>
    </div>
    <div v-for="post in posts" :key="post.id">
      <PostWidget :url="channel + '/' + post.id"/>
    </div>
  </div>
</template>

<script>
import { PostWidget } from 'vue-tg';
import { getTeamTelegramPosts } from '@/api/team';

export default {
  components: {
    PostWidget,
  },

  props: {
    channel: {
      type: String,
      required: true,
    },
    teamId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      posts: [], // Array to hold fetched posts
      offset: 0, // Current offset for pagination
      pageSize: 10, // Number of posts per page
    };
  },

  methods: {
    async fetchPosts() {
      const { teamId, channel, offset, pageSize } = this;

      const { data, success } = await getTeamTelegramPosts({ teamId, channel, offset, pageSize });

      if (success) {
        this.posts = data.items;
      }
    },

    nextPage() {
      this.offset += this.pageSize;
      this.fetchPosts();
    },

    previousPage() {
      if (this.offset >= this.pageSize) {
        this.offset -= this.pageSize;
        this.fetchPosts();
      }
    },
  },

  mounted() {
    this.fetchPosts(); // Fetch posts when the component is mounted
  },
};
</script>

<style scoped>
.pagination-controls {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}
</style>
